// components/ui/alert-dialog.jsx
import React from 'react';

export const AlertDialog = ({ open, onOpenChange, children }) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
      onClick={() => onOpenChange(false)}
    >
      <div 
        className="animate-in fade-in duration-200"
        onClick={e => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export const AlertDialogContent = ({ children, className = "" }) => (
  <div className={`bg-white rounded-lg shadow-lg max-w-md w-full mx-4 ${className}`}>
    {children}
  </div>
);

export const AlertDialogHeader = ({ children, className = "" }) => (
  <div className={`p-6 ${className}`}>
    {children}
  </div>
);

export const AlertDialogFooter = ({ children, className = "" }) => (
  <div className={`flex justify-end gap-2 p-4 bg-gray-50 rounded-b-lg border-t ${className}`}>
    {children}
  </div>
);

export const AlertDialogTitle = ({ children, className = "" }) => (
  <h2 className={`text-lg font-semibold text-gray-900 mb-2 ${className}`}>
    {children}
  </h2>
);

export const AlertDialogDescription = ({ children, className = "" }) => (
  <p className={`text-sm text-gray-500 ${className}`}>
    {children}
  </p>
);

export const AlertDialogAction = ({ children, onClick, className = "" }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 text-sm font-medium rounded-md
      bg-red-600 text-white hover:bg-red-700
      focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 ${className}`}
  >
    {children}
  </button>
);

export const AlertDialogCancel = ({ children, onClick, className = "" }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 text-sm font-medium rounded-md
      bg-white text-gray-700 hover:bg-gray-50 border border-gray-300
      focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 ${className}`}
  >
    {children}
  </button>
);